module.exports = __webpack_public_path__ + "Rectangle 7.a9082c61be1f67ceb60d.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/Rectangle 7.svg
// module id = ../../../../../src/assets/images/Rectangle 7.svg
// module chunks = main